// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 593 ? "component---gatsby-theme-landing-page-src-pages-contentful-landing-page-slug-js" : chunkId) + "-" + {"593":"2769388903e6ad261797","731":"cdbd23ab4e2901fa3fbf","843":"9b276f66cdc01cb178e8"}[chunkId] + ".js";
};